import constants from '../../ahm-constants';

const mapScaleToIncomeType = (scale: string) => {
  if (scale === constants.SCALE.SINGLE) {
    return constants.INCOME_TYPE.SINGLE;
  }

  return constants.INCOME_TYPE.COUPLE;
};

export default mapScaleToIncomeType;
